import axios from 'axios';

import {
  getHeaders,
} from './Utils';

import {
  ENDPOINT_STORY
} from './constants';

export class Story {
  static getAll() {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_STORY}/getAllStories`,
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static getPersonalStructure() {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_STORY}/getPersonalStructure`,
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static getStoryById(id) {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_STORY}/getStoryById`,
      data: {
        storyId: id,
        withGameData: false
      }
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static getStoryByIdWithGameData(id) {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_STORY}/getStoryById`,
      data: {
        storyId: id,
        withGameData: true,
      }
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static getStorysWithUserId(accountId){
    
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_STORY}/getStorysWithUserId`,
      data: {
        accountId: accountId,
      },
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static getStorysByCategory(categoryId){
    
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_STORY}/getStorysByCategory`,
      data: {
        categoryId: categoryId,
      },
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static publish(settings) {
    return axios({
      method: 'post',
      headers: getHeaders(),
      url: `${ENDPOINT_STORY}?fields=gamedata,project`,
      data: {
        resource: [
          {
            owner: window.localStorage.getItem('user_id'),
            gamedata: settings.gamedata,
            description: settings.description,
            duration: settings.duration,
            author: settings.author,
            category: settings.category,
            name: settings.name,
            project: settings.project,
          },
        ],
      },
    }).catch((err) => {
      throw new Error(err);
    });
  }
}

export default Story;



// WEBPACK FOOTER //
// ./src/api/Story.js